export default __webpack_public_path__ + "static/media/peppoLogoWhite.0f42e124.svg";